import { render } from "./contact-info.vue?vue&type=template&id=d242f9ca&scoped=true"
import script from "./contact-info.vue?vue&type=script&lang=js"
export * from "./contact-info.vue?vue&type=script&lang=js"

import "./contact-info.vue?vue&type=style&index=0&id=d242f9ca&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d242f9ca"]])

export default __exports__